import { type LocationDetail } from '@/api/accommodation/types'
import { Typography } from '@/components/ui/typography'
import ConditionsCard from './ConditionsCard'

interface DetailConditionsSectionProps {
  check: LocationDetail['check']
  conditions: LocationDetail['conditions']
  surcharges: LocationDetail['surcharges']
  business: LocationDetail['business']
  surchargePayments: LocationDetail['surchargePayments']
}

export function DetailConditionsSection({
  check,
  conditions,
  surcharges,
  business,
  surchargePayments,
}: DetailConditionsSectionProps) {
  return (
    <div id="conditions" className="scroll-mt-38 space-y-4 lg:scroll-mt-16">
      <Typography variant="h2">Podmínky ubytování</Typography>
      <ConditionsCard
        check={check}
        conditions={conditions}
        surcharges={surcharges}
        business={business}
        surchargePayments={surchargePayments}
      />
    </div>
  )
}
